'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Store, Users, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Store,
  text: 'Get matched with brand initiatives'
}, {
  icon: Users,
  text: 'Monetise your foot traffic'
}, {
  icon: Sparkles,
  text: 'Offer fun experiences to your people'
}];
export function VenuesSection() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-sm font-semibold uppercase tracking-widest text-cyan-600 mb-4">{"For venues & locations & workplaces"}</p>;
    t1 = <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">Have a space, audience, or event?{" "}</h2>;
    t2 = <p className="text-lg text-gray-500 mb-10 max-w-xl mx-auto">Brands want venues, locations and events for sampling, pop-ups, and activations. Organisers run expos, pitch events, and meetups. List your space or event or workplace and get matched.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">{benefits.map(_temp)}</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="py-20 lg:py-28 bg-gray-50"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="max-w-3xl mx-auto text-center">{t0}{t1}{t2}{t3}<Link href="/host-opportunities" className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-bold rounded-full hover:bg-gray-800 transition-all cursor-pointer text-lg">List Your Space, Place or Event<ArrowRight className="h-5 w-5" /></Link></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(benefit) {
  return <div key={benefit.text} className="flex items-center gap-2 text-gray-700"><benefit.icon className="h-5 w-5 text-cyan-600 flex-shrink-0" /><span className="text-sm font-medium">{benefit.text}</span></div>;
}